export const kpiData = [
  {name: 'ResponsivenessSeller', translationKey: 'buyer.invoiceDetails.kpis.responsivenessSeller'},
  {name: 'ResponsivenessDebtor', translationKey: 'buyer.invoiceDetails.kpis.responsivenessDebtor'}
];
